<template>
  <component :is="fieldLayoutComponent" ref="field" :content="content">
    <div class="d-grid gap-3">
      <start-end />
      <div>
        <time-zone v-if="virtual" v-model="selectedTimeZone" class="time-zone" :time-zone-options="timeZoneOptions"
                   :default-time-zone="defaultTimeZone" object-name="event" />
        <input v-else type="hidden" name="event[time_zone]" :value="selectedTimeZone">
      </div>
    </div>
  </component>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

import StartEnd from './start-end'
import FieldLayout from '@/campaign-form-shared/field-layout'
import TimeZone from '@/components/inputs/date-time/time-zone'
import FieldMixin from '@/campaign-form-shared/field-mixin'

export default {
  components: { FieldLayout, StartEnd, TimeZone },

  mixins: [ FieldMixin ],

  props: {
    fieldLayoutComponent: {
      type: Object,
      required: false,
      default() { return FieldLayout}
    }
  },

  computed: {
    ...mapState(['defaultTimeZone', 'timeZoneOptions']),
    ...mapGetters(['startAt', 'endAt', 'virtual', 'timeZone']),

    selectedTimeZone: {
      get() {
        return this.timeZone
      },
      set(newValue) {
        this.$store.commit('setTimeZone', newValue)
      }
    }
  },

  methods: {
    ...mapActions(['updateLocation']),
    ...mapMutations(['setVirtual'])
  }
}
</script>
